import {GET, POST, POST_FILES, PUT} from './core';

export const getEndpointWithPrefix = (endpoint) => {
  return `/prepaid-credits/${endpoint}`;
};

export const searchCreditTopups = (request, token) => {
  const endpoint = getEndpointWithPrefix('search');
  return POST(endpoint, request, token).then((response) => {
    return response;
  });
};

export const getAllPendingTopups = (params, token) => {
  const endpoint = getEndpointWithPrefix('getAllPendingTopups?' + new URLSearchParams(params).toString());
  return GET(endpoint, token).then((response) => {
    return response;
  });
};

export const completeTopup = (request, token) => {
  const endpoint = getEndpointWithPrefix('topup-complete');
  return POST(endpoint, request, token).then((response) => {
    return response;
  });
};

export const InitiateTopup = (request, token) => {
  const endpoint = getEndpointWithPrefix('topup-initiate');
  return POST(endpoint, request, token).then((response) => {
    return response;
  });
};

export const submitBankTransferDetails = (request, token) => {
  try {
    const endpoint = getEndpointWithPrefix('bank-transfer');
    
    return POST(endpoint, request, token)
      .then((response) => {
        return {
          success: true,
          status: 200,
          data: response || {}
        };
      })
      .catch((error) => {
        if (error.message && error.message.includes('Unexpected end of JSON input')) {
          return {
            success: true,
            status: 200,
            data: {}
          };
        }
        throw error;
      });
  } catch (error) {
    throw error;
  };
};

export const submitPaySlip = (request, token, pendingTopUpId) => {
  const endpoint = getEndpointWithPrefix(`${pendingTopUpId}/payment-slip`);
  return POST_FILES(endpoint, request, token).then((response) => {
    return response;
  });
};
